import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { readSession } from '../../utils/session';

export default function usePricingPlans(checkActiveSubscription = false) {
  const navigate = useNavigate();
  const [result, setResult] = useState({ isLoading: true, error: '', priceListY: null, priceListM: null });
  useEffect(() => {
    const session = readSession();
    if (!session) { navigate('/', { replace: true }); return; }
    const user = session.user;
    if (user.isActiveSubscription || (checkActiveSubscription && (user.isTeamMember || user.isComplementary))) {
      navigate('/app/buckets');
      return;
    }
    const controller = new AbortController();
    let active = true;
    const config = { headers: { Authorization: `Bearer ${session.token}` }, signal: controller.signal };
    setResult({ isLoading: true, error: '', priceListY: null, priceListM: null });
    const load = async () => {
      try {
        const [plans, subscription] = await Promise.all([
          axios.get(`${process.env.REACT_APP_API}plans/list`, config),
          checkActiveSubscription ? axios.get(`${process.env.REACT_APP_API}subscriptions/active-subscriptions`, config) : Promise.resolve(null),
        ]);
        if (!active) return;
        if (checkActiveSubscription) {
          const subscriptions = subscription?.data?.data?.subscriptions;
          if (!Array.isArray(subscriptions)) throw new Error('Missing subscription data');
          if (subscriptions.length) { navigate('/app/buckets'); return; }
        }
        const products = plans?.data?.data?.productList;
        const product = Array.isArray(products) ? products.find(item => item?.id === process.env.REACT_APP_MAIN_PLAN_ID) : null;
        const prices = Array.isArray(product?.priceList) ? product.priceList : [];
        const priceListY = prices.find(item => item?.subscriptionType === 'year');
        const priceListM = prices.find(item => item?.subscriptionType === 'month');
        if (!priceListY || !priceListM) throw new Error('Missing plan data');
        setResult({ isLoading: false, error: '', priceListY, priceListM });
      } catch (error) {
        if (active) setResult({ isLoading: false, error: 'Unable to load pricing plans. Please try again.', priceListY: null, priceListM: null });
      }
    };
    load();
    return () => { active = false; controller.abort(); };
  }, [checkActiveSubscription, navigate]);
  return result;
}
